// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-convert {\n  word-break: break-all;\n}\n.tag {\n  color: #013a77;\n  cursor: pointer;\n  word-break: break-all;\n}\n.tag:hover {\n  text-decoration: underline;\n  text-decoration-color: #013a77;\n}\n.user:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
